module.exports = __webpack_public_path__ + "static/media/etc.a12ce01f.png";